export const SCREENS = {
  comments: 'Comments-Tab',
  playbooks: 'Playbooks-Tab',
  associations: 'Associations-Tab',
  participants: 'Participants-Tab',
  login: 'Welcome-Page',
  accounts: 'Accounts-Page',
  associatedContact: 'Associated-Contact-Detail-Page',
  associatedDeal: 'Associated-Deal-Detail-Page',
  associatedTicket: 'Associated-Ticket-Detail-Page',
  associatedCompany: 'Associated-Company-Detail-Page',
  associatedMeeting: 'Associated-Meeting-Detail-Page',
  associateContact: 'Associate-Contact-Page',
  associateDeal: 'Associate-Deal-Page',
  associateTicket: 'Associate-Ticket-Page',
  associateCompany: 'Associate-Company-Page',
  associateMeeting: 'Associate-Meeting-Page',
  associatePannelAssociateTab: 'Associate-Pannel-Associate-Tab',
  associatePannelCreateTab: 'Associate-Pannel-Create-Tab',
  planner: 'Planner-Page',
  discoverabilityBanner: 'Discoverability-Banner',
  discoverabilityModal: 'Discoverability-Modal',
  inMeetingAppTab: 'In-meeting-App-Settings-Tab'
};
export const USAGE_EVENTS_NAMES = {
  addOrUpdateComment: 'Add or Update Comment',
  mapContact: 'Map Contact',
  unmapContact: 'Unmap Contact',
  associate: 'Associate Call to CRM Object',
  dissociate: 'Dissociate CRM Object',
  editObject: 'Edit CRM Object',
  createCrmObject: 'Create CRM Object',
  openPlaybook: 'Open Playbook',
  createDraftCallObject: 'Create Draft Call Object',
  createLineItems: 'Create Line items',
  associateCrmObjectToCreatedCrmObject: 'Associate Crm Object to Created Crm Object'
};
export const ACTIONS = {
  participants: {
    clickMap: {
      action: 'click-map-contact-button',
      description: 'Click "map" contact button'
    },
    clickUnmap: {
      action: 'click-unmap-contact-button',
      description: 'Click "unmap" contact button'
    },
    clickTab: {
      action: 'click-participants-tab',
      description: 'Click Participants Tab'
    },
    clickSendNotification: {
      action: 'click-send-notification',
      description: 'Click send notification button to get co-host permission'
    },
    clickReadNotification: {
      action: 'click-read-notification',
      description: 'Click read notification button to mark as read'
    },
    clickAssociate: {
      action: 'click-associate-contact-button',
      description: 'Click "associate" contact button'
    },
    clickCreate: {
      action: 'click-create-contact-button',
      description: 'Click "create" contact button'
    },
    clickDissociate: {
      action: 'click-dissociate-contact-button',
      description: 'Click "dissociate" contact button'
    },
    clickDissociateCancel: {
      action: 'click-cancel-dissociate-contact-button',
      description: 'Click "cancel-dissociate" contact button'
    },
    clickDissociateConfirm: {
      action: 'click-confirm-dissociate-contact-button',
      description: 'Click "confirm-dissociate" contact button'
    },
    openKnowledgeBase: {
      action: 'open-knowledge-base-link',
      description: 'Open knowledge base link'
    }
  },
  comments: {
    new: {
      action: 'start-new-comment',
      description: 'Start new comment'
    },
    edit: {
      action: 'click-edit-comment',
      description: 'Edit comment'
    },
    delete: {
      action: 'click-delete-comment',
      description: 'Delete comment'
    },
    clickTab: {
      action: 'click-comment-tab',
      description: 'Click Comments Tab'
    },
    save: {
      name: USAGE_EVENTS_NAMES.addOrUpdateComment,
      description: 'Save comment'
    }
  },
  playbooks: {
    clickTab: {
      action: 'click-playbooks-tab',
      description: 'Click Playbooks Tab'
    },
    openPlaybook: {
      name: USAGE_EVENTS_NAMES.openPlaybook,
      description: 'Open playbook item'
    },
    clickPlaybook: {
      action: 'click-playbook',
      description: 'Click on playbook item'
    }
  },
  login: {
    start: {
      action: 'click-start-button',
      description: 'Click start button on home page'
    }
  },
  associations: {
    clickTab: {
      action: 'click-associations-tab',
      description: 'Click Associations Tab'
    },
    clickOpen: {
      action: 'open-in-hubspot',
      description: 'Click Open in HubSpot'
    },
    clickAdd: {
      action: 'click-add-call-association-link',
      description: 'Click "+ Add" on associations tab for object'
    },
    associated: {
      name: USAGE_EVENTS_NAMES.associate,
      description: 'Clicked Add on Associations Page and associated call to company, deal, ticket'
    },
    dissociated: {
      name: USAGE_EVENTS_NAMES.dissociate,
      description: 'Click remove on Associations Page and dissociate CRM object from call object'
    },
    createLineItems: {
      name: USAGE_EVENTS_NAMES.createLineItems,
      description: 'Successfully created new line items'
    },
    associateCrmObjectToCreatedCrmObject: {
      name: USAGE_EVENTS_NAMES.associateCrmObjectToCreatedCrmObject,
      description: 'Successfully associate CRM object to created CRM object'
    },
    clickAssociateSelectToNewCrmObject: {
      action: 'click-associate-select-to-new-crm-object',
      description: 'Click associate select during new CRM object creation'
    },
    clickLineItemsSelect: {
      action: 'click-line-tems-select',
      description: 'Click line items select during new CRM object creation'
    }
  },
  associatedContact: {
    clickOpen: {
      action: 'open-in-hubspot',
      description: 'Click Open in HubSpot'
    }
  },
  associateContact: {
    map: {
      name: USAGE_EVENTS_NAMES.mapContact,
      description: 'Clicked and successfully completed mapping participant to contact'
    },
    unmap: {
      name: USAGE_EVENTS_NAMES.unmapContact,
      description: 'Successfully unmap contact from participant'
    }
  },
  general: {
    clickPreview: {
      action: 'open-detailed-object-view',
      description: 'Open detailed object information, to see properties and values'
    },
    closePreview: {
      action: 'close-detailed-object-view',
      description: 'Close detailed object view'
    },
    clickStartEdit: {
      action: 'start-edit-object',
      description: 'Click edit crm object'
    },
    clickCancelEdit: {
      action: 'cancel-edit-object',
      description: 'Click cancel edit crm object'
    },
    editObject: {
      name: USAGE_EVENTS_NAMES.editObject,
      description: 'Click and save changes during edit crm object'
    },
    closeAssociationPanel: {
      action: 'close-association-panel',
      description: 'Close association pannel'
    },
    switchAssociationPanelTab: {
      action: 'switch-association-panel-tab',
      description: 'Click on tab in associate pannel'
    },
    createCrmObject: {
      name: USAGE_EVENTS_NAMES.createCrmObject,
      description: 'Successfully created new CRM object'
    }
  },
  planner: {
    changeDayInPicker: {
      action: 'click-change-day',
      description: 'Click change day in date picker'
    },
    clickPlannerTableRow: {
      action: 'click-planner-table-row',
      description: 'Click planner table row'
    },
    clickCreateDraftButton: {
      action: 'click-create-draft-button',
      description: 'Click create draft button'
    },
    clickEditDraftButton: {
      action: 'click-edit-draft-button',
      description: 'Click edit draft button'
    },
    clickPastMeetingButton: {
      action: 'click-past-meeting-button',
      description: 'Click past meeting button'
    },
    clickOpenAllCallObjects: {
      action: 'click-open-all-call-objects',
      description: 'Click open all call objects in HubSpot button'
    },
    clickBackToPlannerButton: {
      action: 'click-back-to-planner-button',
      description: 'Click back to planner button'
    },
    clickBackToLiveMeetingButton: {
      action: 'click-back-to-live-meeting-button',
      description: 'Click back to live meeting button'
    },
    clickOpenRecurringMeetingsMenuButton: {
      action: 'click-open-recurring-meetings-menu-button',
      description: 'Click toggle recurring meetings menu button'
    },
    clickOpenCallObjectInHubSpot: {
      action: 'click-open-call-object-in-hubspot',
      description: 'Click open call object in HubSpot button'
    },
    draftCreated: {
      name: USAGE_EVENTS_NAMES.createDraftCallObject,
      description: 'Create a new call object draft for future meeting'
    }
  },
  accounts: {
    connect: {
      action: 'connect-account',
      description: 'Log in to HubSpot account'
    },
    connectNew: {
      action: 'connect-new-account',
      description: 'Connect new HubSpot account'
    }
  },
  discoverabilityBanner: {
    close: {
      action: 'click-close-discoverability-banner',
      description: 'Click close discoverability banner button'
    },
    details: {
      action: 'click-details-button',
      description: 'Click details banner to open marketplace offering'
    }
  },
  discoverabilityModal: {
    close: {
      action: 'click-close-discoverability-modal',
      description: 'Click close discoverability modal button'
    },
    details: {
      action: 'click-details-button',
      description: 'Click details modal to open marketplace offering'
    }
  },
  inMeetingAppTab: {
    startTour: {
      action: 'click-start-tour-button',
      description: 'Click start tour in demo app'
    },
    installApp: {
      action: 'click-install-app-button',
      description: 'Click install app button'
    },
    closeInstalltip: {
      action: 'close-install-tip',
      description: 'Click close install tip'
    }
  }
};